import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { featureFlagQueries } from 'hooks/backend/featureFlags';
import { useGlobalStore } from './store';

export function useSyncFeatureFlagsStore() {
  const { data } = useQuery(featureFlagQueries.list());

  useEffect(() => {
    if (data) {
      useGlobalStore.setState({ flags: data });
    }
  }, [data]);
}
